import { Button } from "Components/Button";
import { Box } from "styles/globalComponents";
import { History } from "lucide-react";
import {
  NewTrackingModel,
  TrackItem,
} from "Pages/PreBudgetConvertionIA/interface";
import { useState } from "react";
import { NewTrackingDisplay } from "Pages/PreBudgetConvertionIA/components/Cart/CartDetails/NewTrackingDisplay";

interface TrackDetailsProps {
  trackingIAProducts: TrackItem[];
  newTrackHistory: NewTrackingModel | null;
}

export const TrackDetails = ({
  trackingIAProducts,
  newTrackHistory,
}: TrackDetailsProps) => {
  const [showTracking, setShowTracking] = useState(false);

  const handleViewTracking = () => {
    setShowTracking(!showTracking);
  };

  return (
    <Box display="flex" direction="column" gap="10" align="start" mb="20">
      <Button onClick={handleViewTracking} outlined>
        <History size={16} />
        Histórico de Alterações ({trackingIAProducts.length})
      </Button>

      {showTracking && newTrackHistory && (
        <NewTrackingDisplay trackingData={newTrackHistory} />
      )}

      {showTracking && !newTrackHistory && trackingIAProducts.length > 0 && (
        <>
          {trackingIAProducts.length > 0 ? (
            <div className="tracking-history">
              <h6>Histórico de Alterações:</h6>
              {trackingIAProducts.map((track) => (
                <div
                  key={track.produto_original.produto_original_match_id}
                  className="track-item"
                >
                  <div className="track-original">
                    <strong>Original:</strong>{" "}
                    {track.produto_original.produto_original_nome}
                    {track.produto_original.produto_original_match_nome !==
                      track.produto_original.produto_original_nome && (
                      <span className="match-info">
                        (Encontrado:{" "}
                        {track.produto_original.produto_original_match_nome})
                      </span>
                    )}
                  </div>
                  <div className="track-corrections">
                    <strong>Substituído por:</strong>
                    {track.items_corretos.length > 0 ? (
                      <ul>
                        {track.items_corretos.map((correction, corrIndex) => (
                          <li key={corrIndex}>
                            {correction.produto_corrigido_nome} (ID:{" "}
                            {correction.produto_corrigido_id})
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <span className="removed">Produto removido</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p>Nenhuma alteração realizada</p>
          )}
        </>
      )}
    </Box>
  );
};
